import { colorTokens } from "../tokens";

// Chart palette tuned for legibility on the white `paper` background. We use the
// *dark* lime here (the brand lime #32ffaa is too light to read as a line/bar).
export const CHART_COLORS = {
  primary: colorTokens.limeDark,
  ink: colorTokens.ink,
  info: colorTokens.info,
  ember: colorTokens.ember,
  sun: colorTokens.sunDark,
  positive: colorTokens.positive,
  warning: colorTokens.warning,
  danger: colorTokens.danger,
  ash: colorTokens.ash,
} as const;

// Ordered palette for categorical series (cycles if exhausted).
export const CHART_SERIES_PALETTE = [
  colorTokens.limeDark,
  colorTokens.info,
  colorTokens.ember,
  colorTokens.sunDark,
  colorTokens.danger,
  colorTokens.ash,
] as const;

export const CHART_GRID_STROKE = colorTokens.smoke;

export const CHART_AXIS_TICK = {
  fontSize: 11,
  fill: colorTokens.ash,
} as const;

// Shared Recharts <Tooltip /> contentStyle so every tooltip matches the cards.
export const CHART_TOOLTIP_STYLE = {
  borderRadius: 12,
  border: `1px solid ${colorTokens.smoke}`,
  fontSize: 12,
  boxShadow: "0 8px 24px rgba(15,15,15,0.08)",
} as const;

export function paletteColor(index: number): string {
  return (
    CHART_SERIES_PALETTE[index % CHART_SERIES_PALETTE.length] ??
    CHART_SERIES_PALETTE[0]
  );
}
